export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-black text-background-50 mb-3">酷看漫画</h4>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed">
              韩漫、日漫、国漫分类整理，汇集玄幻、恋爱、热血等热门类型，免费在线阅读，找好看的漫画一搜即达。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" onClick={(e) => e.preventDefault()} className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门排行', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '精品专题', href: '#carousel' },
                { label: '分类索引', href: '#index' },
                { label: '更新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-xs md:text-sm text-background-300 hover:text-primary-400 transition-colors no-underline"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['韩漫', '日漫', '国漫', '玄幻', '恋爱', '热血', '悬疑', '搞笑', '免费漫画'].map((tag) => (
                <a
                  key={tag}
                  href="#index"
                  onClick={(e) => e.preventDefault()}
                  className="text-[10px] md:text-xs px-2.5 py-1 rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors no-underline whitespace-nowrap"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-400">更多合作伙伴即将加入，敬请期待。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 酷看漫画 kukanmanhua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">
              隐私政策
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">
              服务条款
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}